var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer fill-width text-center text-14"},[_vm._v(" "+_vm._s(_vm.copyright)+" "+_vm._s(_vm.$t('保留所有權利'))),_c('br')])}
var staticRenderFns = []

export { render, staticRenderFns }